import React from "react"
import { InputAdornment, TextField } from "@material-ui/core"
import { useDispatch, useSelector } from "react-redux"
import { updateUnitCil } from "redux/actions/inventories/inventoriesAction"
import { getDecimalFormat } from "helpers/getNumberFormats"
import { useForm } from "hooks/useForm"
import { useDelayAction } from "hooks/fetch-hooks/useDelayAction"
import { UpdateCilComponent } from "./UpdateCilComponent"

export const columnsPortableTab = [
  {
    Header: "Unidad",
    accessor: "number",
    filterable: true,
    filterMethod: ({ value }, row) => {
      return row.number.toLowerCase().includes(value.toLowerCase());
    },
  },
  {
    Header: "Clindro 10 kg",
    Cell: ({ original }) => (<UpdateCilComponent data={original} cil="cil10"/>),
  },
  {
    Header: "Clindro 20 kg",
    Cell: ({ original }) => (<UpdateCilComponent data={original} cil="cil20"/>),
  },
  {
    Header: "Clindro 30 kg",
    Cell: ({ original }) => (<UpdateCilComponent data={original} cil="cil30"/>),
  },
  {
    Header: "Clindro 45 kg",
    Cell: ({ original }) => (<UpdateCilComponent data={original} cil="cil45"/>),
  },
  {
    Header: "Total kg",
    accessor: "totalKg",
    Cell: ({ value }) => (
      <div style={{ float: "right", marginRight: 16 }}>{getDecimalFormat(value)}</div>
    ),
  },
];
